import React from 'react';
import { observer } from 'mobx-react';
import { ProductHat as PackagePickerHat } from '@wix/package-picker-components';
import { useHatProperties } from './useHatProperties';

interface ProductHatProps {
  isCurrentPlan: boolean;
  isRecommended: boolean;
  isOnSale: boolean;
  text?: string;
}

const ProductHatComp: React.FC<ProductHatProps> = ({
  isCurrentPlan,
  isOnSale,
  isRecommended,
  text,
}) => {
  const hatProperties = useHatProperties({
    isCurrentPlan,
    isOnSale,
    isRecommended,
    text,
  });
  return hatProperties ? (
    <PackagePickerHat textWhite={false} {...hatProperties} />
  ) : null;
};

export const ProductHat = observer(ProductHatComp);
